export default __webpack_public_path__ + "static/media/img_signing_illustration.17509046.png";